import { View, Text } from 'react-native';
import { statBarStyles as styles } from './StatBar.styles';

export interface StatBarProps {
  label: string;
  you: number;
  rival: number;
  isDraw: boolean;
  highlightColor: string;
}

export function StatBar({ label, you, rival, isDraw, highlightColor }: StatBarProps) {
  const total = Math.max(you + rival, 1);
  const youPct = Math.max((you / total) * 100, 0.5);
  const rivalPct = Math.max(100 - youPct, 0.5);
  const youWins = you > rival;
  const rivalWins = rival > you;
  const youColor = isDraw ? 'rgba(247,250,252,0.85)' : youWins ? '#6EE7B7' : '#9CA3AF';
  const rivalColor = isDraw ? 'rgba(247,250,252,0.85)' : rivalWins ? '#6EE7B7' : '#9CA3AF';

  return (
    <View style={styles.container}>
      <View style={styles.valuesRow}>
        <Text style={[styles.value, { color: youColor }]}>{you}</Text>
        <Text style={styles.label}>{label}</Text>
        <Text style={[styles.value, { color: rivalColor }]}>{rival}</Text>
      </View>
      <View style={styles.track}>
        <View style={{ flex: youPct, backgroundColor: youWins ? highlightColor : '#475569' }} />
        <View style={styles.trackDivider} />
        <View style={{ flex: rivalPct, backgroundColor: rivalWins ? highlightColor : '#475569' }} />
      </View>
    </View>
  );
}
